export default __webpack_public_path__ + "static/media/hidraulic24.a53e5e47.jpeg";